export enum FilterApplicationTypesID {
  TRAVEL_HISTORY = "f9f3e0e0-3d9d-4d4b-8b5c-6b8f2a6a3f3e",
  ALERT_HISTORY = "a1e2d3b3-9e9d-4e9c-a89e-87c44d179228",
  VEHICLE_HISTORY = "4b76ca40-8c29-4617-837d-a4924d265570",
  COORDINATE_TRAVEL_HISTORY = "05b8e88d-18e4-488c-a9d9-e64cdb8aa144",
  PUMP_PROGRAMMING = "9abfba72-3241-4565-bf7e-1e3396fe1f63",
  PUMP_PROGRAMMING_HISTORY = "deb7163f-b3c9-41ed-a7d4-09b05f00ee20",
  AVERAGE_SPEED_HISTORY = "b39f0a4e-7f71-4b54-9846-b26614faf749",
  VEHICLE_STATE_HISTORY = "fa664a28-76b5-4be7-9fb4-154f88b5c6ae",
  VEHICLE_ANALYTIC_REPORT = "d72c3aac-db53-4aec-98e6-88971627850b",
  INTEGRATION_REPORT = "05ae7ecf-a5a7-4024-b87e-9a3ef463291a",
  MAINTENANCES = "4fc77352-82cd-4815-b324-6c3bf20ca147",
  PUMP_TRAVEL_REPORT = "bb6a6dfe-90b1-4dc5-9294-9f795551f928",
  DRIVERS = "37d0b8f0-bd0d-4ac3-b2e4-8862c62f95de",
  VEHICLES = "0a089354-cc23-4cb6-ab99-a2229a270257",
  LOCATIONS = "d4c5fe35-3183-4cd5-a946-c611165720de",
  WATER_ADDITIONS = "5389f2f3-e2cd-4e20-806a-d45a7c4e46b4",
  WATER_ADDITIONS_BY_TRAVEL = "8b2d3f5e-c3ed-4e30-916b-e56b8d5f47c3",
  CAN_REPORT = "ff253ae0-9ea5-492c-b36b-aaeae246d1c5",
  VEHICLE_CAN_HISTORY = "c3b7d4e8-5a9f-4c2b-a1e6-8d7f9c3b2a1e",
  TRAVEL_ANALYSIS = "b8e4f2a1-6c3d-4e7b-9a5f-1d8c7e2b3f4a",
  TOTAL_ODOMETER_HOURMETER_REPORT = "135a1314-c160-4cad-9302-9f85aaeca9a9",
  CAN_CONSUMPTION_DASHBOARD = "8ec227e5-2c43-46eb-a83f-fb497acd3c0e"
}

export function getFilterApplicationTypeName(id: string | undefined): string | undefined {
  if (!id) return undefined;

  for (const [key, value] of Object.entries(FilterApplicationTypesID)) {
    if (value === id) {
      return key;
    }
  }

  return undefined;
}
